import classNames from 'classnames';
import { CorporateViewTabGroup } from './CorporateViewTabGroup';
import { UscgMapLayout } from './UscgMapLayout';
import { useUscgMapContext } from './CorporateViewTabs/LayersTab/UscgMapContext';

export default function MapPage() {
  const { isMapVisible } = useUscgMapContext();

  return (
    <div className="iap-response">
      <div
        className={classNames('maincontent-no-padding iap-response__main', {
          'iap-response__main--map-visible': isMapVisible,
        })}
      >
        <UscgMapLayout>
          <CorporateViewTabGroup
            currentMode={''}
            updateMode={() => {}}
            currentPhase={0}
          />
        </UscgMapLayout>
      </div>
    </div>
  );
}
